import { get } from 'lodash'
import React, { useContext, useEffect, useState } from 'react'
import styled, { withTheme } from 'styled-components'
import Menu from '../menu'
import {
  getSelectedMenuInfo,
  isGroupMenu,
  isNewTabMenu,
  openInNewTab,
  traverseTree,
} from '../utils'
import ActionsContext from './ActionsContext'
import Iconfont from './Iconfont'
import { setSideMenuStore } from './storage'

const color = 'rgba(255,255,255,.85)'
const compatibleColor = '#a1d7ff'
const { SubMenu, Item: MenuItem } = Menu
const TNTMenu = styled(Menu)`
  background: none !important;
  &.ant-menu.ant-menu-root {
    position: relative;
    transition: none !important;
    padding-top: 10px;
    border-right: none;
    text-rendering: optimizeLegibility;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    height: calc(100vh - ${(props) => `${props.theme.headerHeight}px`});
    overflow-y: auto;
    overflow-x: hidden;
    .collapseIconPlacementBottom & {
      padding-bottom: 36px;
    }
    .tnt-themeS1 & {
      overflow-x: unset;
      box-shadow: 10px 0 10px -5px rgba(0, 0, 0, 0.1);
      z-index: 2;
    }
    scrollbar-width: none;
    -ms-overflow-style: none;

    &::-webkit-scrollbar {
      display: none;
    }
    &::-moz-scrollbar {
      display: none;
    }

    /** 一级结点是菜单样式开始 */
    & > .ant-menu-item {
      & > .tnt-icon:first-child {
        font-size: 16px;
      }
    }

    .ant-layout-sider-collapsed & {
      & > .ant-menu-item {
        & > .tnt-icon:first-child {
          padding-left: 8px;
        }
        a {
          visibility: hidden;
        }
      }
    }
    /** 一级结点是菜单样式结束 */

    .ant-menu-item:active,
    .ant-menu-submenu-title:active {
      background: none;
    }

    .ant-menu-submenu .ant-menu-sub {
      background: #212635;
      border-radius: 0 0 2px 2px;
      .compatible & {
        background: #07408d !important;
      }
      .tnt-themeS1 & {
        background: #fff !important;
      }

      // 蓝色系列 菜单展开区域颜色
      .tnt-themeS3 & {
        background: #07408d !important;
      }
    }
    .ant-menu-submenu.ant-menu-submenu-active,
    .ant-menu-submenu.ant-menu-submenu-selected {
      background: rgba(47, 129, 247, 0.25) !important;
      .tnt-themeS1 & {
        background: ${(props) => props.theme.dividerColor} !important;
      }

      // 蓝色系 一级菜单的选中效果
      .tnt-themeS3 & {
        background: #204085 !important;
      }
    }
    & > .ant-menu-submenu .ant-menu-submenu.ant-menu-submenu-active,
    & > .ant-menu-submenu .ant-menu-submenu.ant-menu-submenu-selected {
      background: none !important;
      .tnt-themeS1 & {
        background: ${(props) => props.theme.dividerColor} !important;
      }
      // 蓝色系 子级菜单级的选中效果
      .tnt-themeS3 & {
        background: #204085 !important;
      }
    }
    .ant-menu-item {
      margin: 0;
      font-size: 14px;
      padding-left: 54px !important;
      height: ${({ size }) => (size === 'large' ? '40px' : '36px')};
      line-height: ${({ size }) => (size === 'large' ? '40px' : '36px')};
    }

    & > .ant-menu-item {
      padding-left: 24px !important;
      width: 100%;

      & > .tnt-icon {
        margin-right: 12px;
      }
      & > a {
        display: inline-block;
      }
    }

    .ant-menu-submenu-title {
      position: relative;
      color: ${(props) => (props.theme.compatible ? compatibleColor : color)};
      .tnt-themeS1 & {
        color: ${(props) => props.theme.primaryTextColor};
      }
      height: ${({ size }) => (size === 'large' ? '40px' : '36px')};
      line-height: ${({ size }) => (size === 'large' ? '40px' : '36px')};
      .tnt-icon {
        .tnt-themeS1 & {
          color: ${(props) => props.theme.lightIconColor};
        }
      }
      & > .tnt-icon {
        position: absolute;
        right: 20px;
        top: 1px;
        font-size: 10px;
      }

      // 蓝色系主题
      .tnt-themeS3 & {
        color: #fff;
      }
      .tnt-icon {
        .tnt-themeS3 & {
          color: #fff;
        }
      }
    }

    & > .ant-menu-submenu .ant-menu-submenu .ant-menu-submenu-title {
      margin-top: 0;
      margin-bottom: 0;
      padding-left: 54px !important;
    }
  }

  &.ant-menu .menu-arrow-right {
    color: ${(props) => (props.theme.compatible ? compatibleColor : color)};
  }

  .ant-menu-item,
  .ant-menu-item > a {
    color: ${(props) => (props.theme.compatible ? compatibleColor : color)};
    .tnt-themeS1 & {
      color: ${(props) => props.theme.primaryTextColor};
    }
    &:hover {
      color: #fff;
      .tnt-themeS1 & {
        color: ${(props) => props.theme.primaryColor};
      }
    }

    // 蓝色系列
    .tnt-themeS3 & {
      color: #fff;
    }
    &:hover {
      .tnt-themeS3 & {
        color: #fff;
      }
    }
  }
  & > .ant-menu-item.ant-menu-item-selected,
  &.ant-menu:not(.ant-menu-horizontal) .ant-menu-item-selected {
    color: rgba(255, 255, 255, 0.85);
    background-color: ${(props) => props.theme.primaryColor};
    .compatible & {
      background-color: #013479;
    }
    & > a {
      .tnt-themeS1 & {
        color: #fff;
      }
    }
    .tnt-themeS1 & {
      color: #fff;
      background-color: ${(props) => props.theme.primaryColor};
    }

    // 蓝色系 子项选中颜色
    .tnt-themeS3 & {
      color: #fff;
      background: #013479;
      &::after {
        content: '';
        display: none;
      }
    }
  }
  .ant-menu-submenu.ant-menu-submenu-selected {
    .tnt-themeS2 & {
      background: #141825;
    }
    .tnt-themeS2.compatible & {
      background: rgba(47, 129, 247, 0.25) !important;
    }
  }
`
const MenuTitle = styled.span`
  font-size: 14px;
  .large-size & {
    font-size: 15px;
  }
  color: rgba(255, 255, 255, 0.85);
  .compatible & {
    color: #a1d7ff;
  }
  .tnt-themeS1 & {
    color: ${(props) => props.theme.primaryTextColor};
  }
  .tnt-icon {
    margin-right: 12px;
    font-size: 16px;
    position: relative;
    top: 1px;

    .large-size & {
      font-size: 18px;
      top: auto;
    }
    .tnt-themeS1 & {
      /* color: #7e8081; */
      color: ${(props) => `${props.theme.iconColor}`};
    }
  }
`

export default withTheme((props) => {
  const actions = useContext(ActionsContext)
  const {
    language,
    menus = [],
    formatMenuPath,
    changeRouter,
    selectedKey,
    openKeys,
    onSelect,
    onBeforeChange,
    onChange,
    onOpenChange,
    collapsed,
  } = props
  const { subMenu, parentMenus } = getSelectedMenuInfo(selectedKey, menus)
  const [selectedKeys, setSelectedKeys] = useState([get(subMenu, 'code')])
  const onSelectMenu = (param) => {
    const { subMenu, parentMenus } = getSelectedMenuInfo(param.key, menus) || {}
    const params = {
      ...param,
      data: subMenu,
    }
    const defaultBeforeChange = ({ data }) => !isNewTabMenu(data)
    const defaultSelect = ({ data }) => {
      const { path } = data || {}
      const formatPath = formatMenuPath || ((path) => path)

      if (isNewTabMenu(data)) {
        openInNewTab(formatPath(data?.path, data))
        return
      }

      const routerPrefix = window.location.pathname.match(/(^\/[^\/]+)/i)?.[1]

      if (path?.startsWith(routerPrefix)) {
        const forwardPath = formatPath(path, data)
        changeRouter
          ? changeRouter(forwardPath, data)
          : window.history.pushState(data, data?.name, forwardPath)
      } else {
        window.location.href = formatPath(path, data)
      }
    }
    const finalSelect = onSelect || defaultSelect

    if (param.key !== get(selectedKeys, '0')) {
      const finalBeforeChange = onBeforeChange || defaultBeforeChange

      if (finalBeforeChange(params, get(selectedKeys, '0'))) {
        // SideMenu菜单收起状态
        if (collapsed) {
          const newOpenKeys = parentMenus?.map(({ code }) => code).reverse()

          onOpenChange(newOpenKeys)
          setSideMenuStore({
            openKeys: newOpenKeys,
            beforeOpenKeys: newOpenKeys,
          })
        }
        setSelectedKeys([param.key])
        onChange && onChange(params)
      }
    }
    actions.setSelectedMenuKey(param.key)
    setSelectedKeys([param.key])

    finalSelect(params)
  }
  const getExpandIcon = (code) => {
    if (props.theme.compatible) {
      return openKeys.includes(code) ? 'minus' : 'plus'
    }

    return openKeys.includes(code) ? 'up' : 'down'
  }
  const onOpenKeysChange = (keys) => {
    const openKey = keys.find((key) => !openKeys.includes(key))
    // const closeKey = openKeys.find(key => !keys.includes(key));
    let newOpenKeys = keys

    const findParentGroupKey = (key, openKeys) => {
      let parentGroupKey

      traverseTree(menus, (node, pnode) => {
        if (node.code === key) {
          if (pnode && openKeys.includes(pnode?.code)) {
            parentGroupKey = pnode?.code
          }

          return false
        }
      })

      return parentGroupKey
    }

    // 展开openKey
    if (openKey) {
      // 父子关系展开
      const parentGroupKey = findParentGroupKey(openKey, openKeys)
      if (parentGroupKey) {
        newOpenKeys = keys.length > 2 ? [parentGroupKey, openKey] : keys
      } else {
        newOpenKeys = [openKey]
      }
    } else {
      // 收起closeKey
      newOpenKeys = keys
    }

    onOpenChange(newOpenKeys)
  }

  useEffect(() => {
    setSelectedKeys([selectedKey])
    if (selectedKey && !collapsed && parentMenus?.length) {
      onOpenChange(parentMenus?.map(({ code }) => code).reverse())
    }
    actions.setSelectedMenuKey(selectedKey)
  }, [selectedKey])

  actions.off('menuSelect', onSelectMenu)
  actions.on('menuSelect', onSelectMenu)

  return (
    <TNTMenu
      mode="inline"
      defaultSelectedKeys={[]}
      openKeys={openKeys}
      selectedKeys={selectedKeys}
      onOpenChange={onOpenKeysChange}
    >
      {menus?.map((menu) => {
        const MenuLink = ({ menuName, enName, path }) => (
          <a href={path} onClick={(evt) => evt.preventDefault()}>
            {
              {
                cn: menuName,
                en: enName,
              }[language]
            }
          </a>
        )

        if (isGroupMenu(menu)) {
          const getSubMenuProps = ({ code, groupIcon, groupName, enName }, isSubGroup = false) => ({
            key: code,
            title: (
              <MenuTitle
                style={collapsed && isSubGroup ? { color: props.theme.primaryTextColor } : {}}
              >
                {!isSubGroup && <Iconfont type={groupIcon} />}
                {collapsed && !isSubGroup
                  ? ''
                  : {
                      cn: groupName,
                      en: enName,
                    }[language]}
              </MenuTitle>
            ),
            expandIcon: collapsed ? null : <Iconfont /*  */ type={getExpandIcon(code)} />,
          })

          return (
            <SubMenu {...getSubMenuProps(menu)} onClick={onSelectMenu}>
              {menu?.children?.map((menu) => {
                if (isGroupMenu(menu)) {
                  return (
                    <SubMenu {...getSubMenuProps(menu, true)} onClick={onSelectMenu}>
                      {menu?.children?.map(({ code, ...menu }) => (
                        <MenuItem key={code}>
                          <MenuLink {...menu} style={{ paddingLeft: '24px' }} />
                        </MenuItem>
                      ))}
                    </SubMenu>
                  )
                }

                return (
                  <MenuItem key={menu?.code}>
                    <MenuLink {...menu} />
                  </MenuItem>
                )
              })}
            </SubMenu>
          )
        }

        return (
          <MenuItem key={menu.code} onClick={onSelectMenu}>
            <Iconfont type={menu.icon} />
            <MenuLink {...menu} />
          </MenuItem>
        )
      })}
    </TNTMenu>
  )
})
